import config from 'js/app/config';

import type { PartnerLogoData } from 'bundles/unified-common/components/partner-logos/PartnerLogo';

import _t from 'i18n!nls/unified-common';

const getPartnerData = (): PartnerLogoData[] => {
  return [
    {
      name: _t('Google'),
      logo: `${config.url.imageProxyRoot}https://coursera-university-assets.s3.amazonaws.com/4a/cb36835ae3421187080898a7ecc11d/Google-G_360x360.png`,
      href: `${config.url.base}google-career-certificates`,
    },
    {
      name: _t('DeepLearning.AI'),
      logo: `${config.url.imageProxyRoot}https://coursera-university-assets.s3.amazonaws.com/b4/5cb90bb92f420b99bf323a0356f451/Icon.png`,
      href: `${config.url.base}explore/deep-learning-ai-online-courses`,
    },
    {
      name: _t('Stanford University'),
      logo: `${config.url.imageProxyRoot}https://images.ctfassets.net/00atxywtfxvd/1s6p4WQHsv79stjgyiWBtI/d55f3608a884d6d1e48f78935b73362f/3c8a16b167a785920d061664a6512c3a60cdb30e.png`,
      href: `${config.url.base}explore/stanford-online-courses`,
    },
    {
      name: _t('IBM'),
      logo: `${config.url.imageProxyRoot}https://images.ctfassets.net/wp1lcwdav1p1/3toC4I7jbWxiedfxiyNjtT/735faeaf976a9692f425f8c3a7d125dc/1000px-IBM_logo.svg.png`,
      href: `${config.url.base}explore/ibm-online-courses`,
    },
    {
      name: _t('University of Pennsylvania'),
      logo: `${config.url.imageProxyRoot}https://images.ctfassets.net/00atxywtfxvd/3Y7rH8FUwg4eai7LK5j9u3/880203b6e241e81112bf48f252ca8e72/Penn-badge.png`,
      href: `${config.url.base}explore/university-of-pennsylvania-online-courses`,
    },
    {
      name: _t('Microsoft'),
      logo: `${config.url.imageProxyRoot}https://images.ctfassets.net/00atxywtfxvd/11pJTA8yOZPwVRMKnSKPRz/340cf59915e8ce0d3b993d39959972d6/eded33b5eb1694336861de4bfda6d36bf72b7780.png`,
      href: `${config.url.base}explore/microsoft-certificates`,
    },
    {
      name: _t('University of Michigan'),
      logo: `${config.url.imageProxyRoot}https://images.ctfassets.net/wp1lcwdav1p1/60SA8pGxPXMmJf4n7umK1H/ccec31bbe2358210bf8391dcba6cd2f1/umich.png`,
      href: `${config.url.base}explore/university-of-michigan-online-courses`,
    },
    {
      name: _t('Meta'),
      logo: `${config.url.imageProxyRoot}https://images.ctfassets.net/00atxywtfxvd/4UiGf0SnbrHmjWznsuTnQc/3a567e1c87d81f44de01a7659776c8a9/1148622b99ae74a78e3984d7955d16587e365616.png`,
      href: `${config.url.base}explore/meta-online-courses`,
    },
    {
      name: _t('Adobe'),
      logo: `${config.url.imageProxyRoot}https://coursera-university-assets.s3.amazonaws.com/d9/7ac5ee1c0247dab299ec6a8343f16d/Adobe-A-square.png`,
      href: `${config.url.base}explore/adobe-hub-page`,
    },
    {
      name: _t('Vanderbilt'),
      logo: `${config.url.imageProxyRoot}https://images.ctfassets.net/00atxywtfxvd/2xT8bRd5zUzh26boQdnz6/ad837efbdcb2bca5ae3b728fb16814a4/image__1_.png`,
      href: `${config.url.base}explore/vanderbilt-university-online-courses`,
    },
    {
      name: _t('Amazon Web Services'),
      logo: `${config.url.imageProxyRoot}https://coursera-university-assets.s3.amazonaws.com/a4/7cd68a658840ddbb95c38cdd0bbc8e/aws-logo-icon-PNG-Transparent-Background.png`,
      href: `${config.url.base}partners/aws`,
    },
  ];
};

export default getPartnerData;
